import styled from 'styled-components';
import Modal from 'react-rainbow-components/components/Modal';
import { Accordion, AccordionSection } from 'react-rainbow-components';
import {
    GREY_200,
    GREY_400,
    GREY_700,
    PURPLE_100,
    PURPLE_500,
    PURPLE_800,
} from '../../../../../constants';

export const StyledModal = styled(Modal)`
    width: 600px;
    max-height: 80vh;

    > div:last-child {
        overflow-y: auto;
        padding: 1rem 1.5rem 1.5rem;
    }
`;

export const ModalTitle = styled.h2`
    font-size: 1rem;
    font-weight: 700;
    color: ${GREY_700};
    font-family: 'Lato Bold', Arial, Helvetica, sans-serif;
`;

export const ToolCallList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const StyledAccordion = styled(Accordion)`
    border: 1px solid ${GREY_200};
    border-radius: 0.5rem;
    overflow: hidden;
`;

export const StyledAccordionSection = styled(AccordionSection)`
    margin-bottom: 0;

    button {
        background: ${PURPLE_100};
        color: ${PURPLE_800};
        font-size: 0.8125rem;
        font-family: 'Lato Bold', Arial, Helvetica, sans-serif;
        font-weight: 700;
        border: none;
        border-radius: 0;
        padding: 0.625rem 0.75rem;
        min-height: unset;
        box-shadow: none;

        &:hover {
            background: ${PURPLE_100};
            color: ${PURPLE_500};
            box-shadow: none;
        }

        &:focus {
            box-shadow: none;
        }

        svg {
            color: ${PURPLE_800};
        }
    }
`;

export const ToolCallDetails = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;

export const DetailSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;

export const SectionLabel = styled.p`
    font-size: 0.6875rem;
    font-weight: 700;
    font-family: 'Lato Bold', Arial, Helvetica, sans-serif;
    color: ${GREY_400};
    text-transform: uppercase;
    letter-spacing: 0.05em;
`;

export const MonacoContainer = styled.div<{ $height: number }>`
    height: ${({ $height }) => $height}px;
    border-radius: 0.375rem;
    overflow: hidden;
    border: 1px solid ${GREY_200};
`;

export const EmptyResult = styled.p`
    font-size: 0.75rem;
    color: inherit;
    padding: 0.25rem 0;
`;

export const ErrorBlock = styled.pre`
    background: #fdf0ef;
    border-radius: 0.375rem;
    padding: 0.5rem 0.75rem;
    font-size: 0.75rem;
    line-height: 1.5;
    color: #c0392b;
    white-space: pre-wrap;
    word-break: break-all;
    overflow-wrap: break-word;
    margin: 0;
    font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
`;
